import React, { FC, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { Input, Button, Modal, Row, Col, Radio, Checkbox } from "antd";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "reducers/rootReducer";
import { ReactSVG } from "react-svg";
import { SocketTopics } from "constants/enums";
import { wrapRequestPayload } from "../../../helpers/request/RequestPayload";
import { generateUUID } from "utils/appUtil";
import { GET_TICKET_PAGES, SAVE_RECORDING } from "../../../reducers/reducer";

let timeout: NodeJS.Timeout;

const TableFilterModal: FC<{
  onClose?: () => void;
  socket?: ISocket;
  columns?: any;
  tableHideList?: any;
  onChange?: any;
}> = ({ onClose, socket, columns, tableHideList, onChange }) => {
  const dispatch = useDispatch();
  const [saving, setSaving] = useState<boolean>(false);
  const [pages, setPages] = useState<any>([]);
  const [selectedGroups, setSelectGroups] = useState<any>();
  const { encrypted_token } = useSelector((state: RootState) => state.auth);
  const { search } = useLocation();

  useEffect(() => {
    if (socket.client) {
    }
  }, [socket.client]);

  const handleCancel = () => {
    onClose();
  };

  const handleOk = (values: any) => {};

  useEffect(()=>{
    setSelectGroups(columns?.filter((x)=>{
      return tableHideList?.indexOf(x.key) === -1
    }).map((x)=>{return x.key}))
  }, [])

  return (
    <Modal
      title={`Filter columns`}
      visible={true}
      onOk={handleOk}
      onCancel={handleCancel}
      width="480px"
      className="beam-modal scrollable"
      footer={[]}
      destroyOnClose={true}
      closable={true}
    >
      <Row className="scrollable-body mt-4">
        <Col span={24}>

          <Checkbox.Group
            className="plain-radios w-100"
            onChange={(e) => {
              setSelectGroups(e);
            }}
            value={selectedGroups}
          >
            {columns &&
              columns.map((column, index) => (
                <Row className="person-item" key={index}>
                  <Col span={21}>
                    <h5>{column?.title}</h5>
                  </Col>
                  <Col span={3} className="d-block t-right">
                    <Checkbox
                      value={column?.key}
                      className="green-radio"
                    ></Checkbox>
                  </Col>
                </Row>
              ))}
          </Checkbox.Group>
        </Col>
      </Row>

      <Row className="action-grp mt-4 sticky-footer">
        <Col span={24} className="pr-2">
          <Button
            className="beam-btn green-btn cover w-full"
            onClick={() => {
              const hide = [];
              columns?.map((x)=>{
                if(selectedGroups?.indexOf(x.key) === -1){
                  hide.push(x.key)
                }
              })
              onChange(hide);
            }}
          >
            Save
          </Button>
        </Col>
      </Row>
    </Modal>
  );
};

export default TableFilterModal;
